import { CategoryManagement } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

// AdminManageCategoryServices contains functions to interact with category management-related APIs.
// Each function corresponds to a specific API endpoint for tasks such as fetching category, updating category status, etc.
export const AdminManageCategoryServices = {
  /**
   * Function for fetching category data based on query parameters.
   * @param {Object} queryParams - Query parameters for fetching category.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get category API.
   */
  getCategoryService: async (queryParams) => {
    try {
      const payload = {
        ...CategoryManagement.getCategoryList,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for adding a new category.
   * @param {Object} bodyData - New category information.
   * @returns {Promise<Object>} - A promise that resolves to the response from the add category API.
   */
  addCategoryData: async (bodyData) => {
    try {
      const payload = {
        ...CategoryManagement.addCategory,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for deleting a category.
   * @param {string} id - ID of the category to be deleted.
   * @returns {Promise<Object>} - A promise that resolves to the response from the delete category API.
   */
  deleteCategory: async (id) => {
    try {
      const payload = {
        ...CategoryManagement.deleteCategory(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for fetching a single category.
   * @param {string} id - ID of the category to be fetched.
   * @returns {Promise<Object>} - A promise that resolves to the response from the get single category API.
   */
  getSingleCategoryService: async (id) => {
    try {
      const payload = {
        ...CategoryManagement.getSingleCategory(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },

  /**
   * Function for updating a category.
   * @param {Object} bodyData - Updated category information.
   * @param {string} id - ID of the category to be updated.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update category API.
   */
  updateCategoryService: async (bodyData, id) => {
    try {
      const payload = {
        ...CategoryManagement.updateCategory(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  /**
   * Function for updating a category status.
   * @param {Object} bodyData - Updated category status.
   * @param {string} id - ID of the category to be updated.
   * @returns {Promise<Object>} - A promise that resolves to the response from the update category status API.
   */
  updateCategoryStatus: async (id, bodyData) => {
    try {
      const payload = {
        ...CategoryManagement.updateCategoryStatus(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
    }
  },
};
